<template>
  <div>
    <subscription-requester :show="showModal"
                            :name="name"
                            @close="showModal = false">
    </subscription-requester>

    <div class="my-magazines__magazine-content">
      <h3 class="my-magazines__magazine-heading">
        {{ name }}
      </h3>
      <div class="my-magazines__magazine-image-wrapper">
        <img :src="imageUrl + '?width=540'"
             alt="Magazine Cover Image">
      </div>
      <div v-if="articles && articles.length"
           class="my-magazines__magazine-articles">
        <h4 class="my-magazines__magazine-articles-heading">
          Top Articles
        </h4>
        <ul>
          <li v-for="(article, index) in articles"
              :key="index">
            {{ article }}
          </li>
        </ul>
      </div>

      <div class="my-magazines__magazine-button-wrapper">
        <template v-if="hasValidSubscription">
          <a :href="magazineUrl"
             class="btn btn-accent-2">
            View Magazine
          </a>
        </template>
        <template v-else>
          <a v-if="canBuy"
             :href="purchaseUrl"
             class="btn btn-accent-2">Purchase Subscription</a>
          <strong v-else-if="cannotPurchaseText">
            {{ cannotPurchaseText }}
          </strong>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SubscriptionRequester from "~/Components/Accounts/SubscriptionRequester.vue";

export default {
  name: "MagazineItem",
  components: {
    SubscriptionRequester,
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    magazineUrl: {
      type: String,
      default: null,
    },
    purchaseUrl: {
      type: String,
      default: null,
    },
    imageUrl: {
      type: String,
      default: null,
    },
    articles: {
      type: Array,
      default: null,
    },
    hasValidSubscription: {
      type: Boolean,
      default: false,
    },
    canBuy: {
      type: Boolean,
      default: false,
    },
    cannotPurchaseText: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      showModal: false,
    };
  },
};
</script>
